document.addEventListener("DOMContentLoaded", function () {
    const slider = document.querySelector('.JS-photo-slider-detail-top');
    if (!slider)
        return;

    // klony Swiperu (loop) nejsou v lightgallery - klik predame odpovidajicimu realnemu slidu
    slider.addEventListener('click', function (e) {
        const item = e.target.closest('.swiper-slide-duplicate .JS-lightgallery-item');
        if (!item)
            return;

        e.preventDefault();
        const index = item.closest('.swiper-slide-duplicate').dataset.swiperSlideIndex;
        const realItem = slider.querySelector('.swiper-slide[data-swiper-slide-index="' + index + '"]:not(.swiper-slide-duplicate) .JS-lightgallery-item');
        realItem && realItem.click();
    });
});
